import useMutationApi from 'src/api/useMutationApi';
import { OrganizationConfig } from './useOrganizationConfig';
import { useQueryClient } from '@tanstack/react-query';

export interface UpdateOrgConfigRequest {
  enabledModules?: string[];
  logoUrl?: string | null;
  timezone?: string;
}

interface UpdateOrgConfigResponse {
  organizationConfig: OrganizationConfig;
}

const useUpdateOrganizationConfig = () => {
  const queryClient = useQueryClient();
  return useMutationApi<
    UpdateOrgConfigRequest,
    UpdateOrgConfigResponse,
    UpdateOrgConfigResponse
  >({
    endpoint: 'organization/config',
    method: 'POST',
    successMessage: 'Organization configuration updated successfully',
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['organization/config'],
        });
      },
    },
  });
};

export default useUpdateOrganizationConfig;
